<button
    class="dropdown-button"
    mat-button
    [matMenuTriggerFor]="menu"
    [ngStyle]="{ 'width.rem': dropdownWidth() }">
    <span class="text-subtitle-1"
        >{{ activeFiltersInDropdown().length }}
        @if (currentWidth() > ActiveFilterContentComponent.DROPDOWN_WIDTH_REM_WITH_MARGIN) {
            {{ 'otherFilters' | transloco: { COUNT: activeFiltersInDropdown().length } }}
        }
    </span>
    <fa-icon
        class="m-auto"
        size="sm"
        [icon]="['fas', 'ellipsis-vertical']" />
</button>
<mat-menu
    #menu="matMenu"
    class="filters-menu">
    @for (filter of activeFiltersInDropdown(); track filter.id) {
        <app-active-filter-item
            [filter]="filter"
            [isInDropDown]="true"
            (click)="$event.stopPropagation()" />
    }
</mat-menu>
